export const GRID = "#eaeaea";
export const AXIS = "#eaeaea";
